import React from 'react';
import Config from './modules/config';
import T from './modules/translation';

class Tips extends React.Component {

  static MAX_INDEX = 11;

  constructor(props) {
    super(props);
    this.state = {
      index: Config.getInstance().get("tipsIndex", 0)
    }
    this.onNext = this.onNext.bind(this);
    this.hideTips = this.hideTips.bind(this);
    this.showTips = this.showTips.bind(this);
  }

  onNext() {
    Config.getInstance().set("tipsIndex", parseInt(this.state.index) + 1);
    this.setState(state => ({
      index: parseInt(state.index) + 1
    }));
  }

  hideTips() {
    Config.getInstance().set("tipsIndex", Tips.MAX_INDEX + 1);
    this.setState({
      index: Tips.MAX_INDEX + 1
    });
  }

  showTips() {
    Config.getInstance().set("tipsIndex", 0);
    this.setState({
      index: 0
    });
  }

  render() {
    const language = window.navigator.userLanguage || window.navigator.language;
    if (!language.includes("ja")) {
      return null;
    } else if (this.state.index > Tips.MAX_INDEX) {
      return (        
        <div className="text-end me-1">
          <i className="bi bi-question-circle" onClick={this.showTips}></i>
        </div>
      );
    }
    return (
      <div className="tips-panel card">
        <div className="card-body">
          <div className="mb-3">
            [TIPS {parseInt(this.state.index) + 1}] &nbsp;
            {T.get("tips" + this.state.index)}
          </div>
          <div className="float-start">
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.hideTips}>
              <i className="bi bi-x-circle" aria-hidden="true"></i>
            </button>
          </div>
          <div className="float-end">
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.onNext}>
              <i className="bi bi-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Tips;